import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Target, FileText, Users } from 'lucide-react';
const problems = [{
  icon: FileText,
  title: 'Content Creation Struggles',
  description: 'Schools lack the time and resources to create engaging, curriculum-aligned digital content that resonates with modern learners.',
  color: 'bg-red-100 text-red-600'
}, {
  icon: Target,
  title: 'Reaching the Right Schools',
  description: 'EdTech startups struggle to connect with decision-makers and build trust with educational institutions.',
  color: 'bg-blue-100 text-blue-600'
}, {
  icon: AlertCircle,
  title: 'Marketing Misalignment',
  description: 'Creating marketing materials that align with curriculum standards and educational best practices is complex and time-consuming.',
  color: 'bg-yellow-100 text-yellow-600'
}, {
  icon: Users,
  title: 'Low Parent Engagement',
  description: 'Schools and EdTech companies find it challenging to build meaningful connections with parents and the wider community.',
  color: 'bg-green-100 text-green-600'
}];
export function Problems() {
  return <section id="about" className="py-20 px-4 bg-white" data-id="element-172">
      <div className="max-w-7xl mx-auto" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-174">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-175">
            The Challenges Schools & EdTech Companies Face
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-176">
            We understand the unique obstacles in educational marketing and
            outreach
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-177">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          scale: 1.03
        }} className="bg-white rounded-3xl p-8 shadow-lg border-4 border-gray-100 hover:border-purple-200 transition-all" data-id="element-178">
              <div className={`inline-flex p-4 rounded-2xl ${problem.color} mb-4`} data-id="element-179">
                <problem.icon size={32} data-id="element-180" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-181">
                {problem.title}
              </h3>
              <p className="text-gray-600 text-lg" data-id="element-182">{problem.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}